import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { time } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { DateService, HelperService } from 'app/services';

import * as moment from 'moment';

@Component({
  selector: 'app-block-appointment-dialog',
  templateUrl: './block-appointment-dialog.component.html',
  styleUrls: ['./block-appointment-dialog.component.scss'],
})
export class BlockAppointmentDialogComponent implements OnInit {
  constructor(private dateService: DateService, private helperService: HelperService) {}
  @Input() appointment: any;

  @Output() onSubmit = new EventEmitter();

  validate: any;
  acFocus: any = {
    calendar: false,
    customer: false,
    vehicle: false,
    estimate: false,
    user: false,
    note: false,
  };
  selectedTime: any = {
    start: '',
    end: '',
  };
  duration: any = 60;
  endTimeDropdown: any[] = [];
  times = time;
  focus: any = {};

  ngOnInit() {
    const endTime = new Date(this.appointment.endDateTime).getTime();
    const startTime = new Date(this.appointment.startDateTime).getTime();
    this.duration = (endTime - startTime) / 60000;
    this.setSelectedTime();
    this.onSubmit.emit(this.appointment);
  }

  onSelectStartTime(event) {
    this.getTimeDiffrence(event.value);

    this.appointment.time.start = event.value;
    if (event.i < 92) {
      if (this.appointment._id) {
        this.setEndTime(event.i + this.duration / 15);
      } else {
        this.setEndTime(event.i + 4);
      }
      this.setNextEndDate(true);
    } else if (event.i === 92) {
      this.setEndTime(0);
      this.setNextEndDate(false);
    } else if (event.i === 93) {
      this.setEndTime(1);
      this.setNextEndDate(false);
    } else if (event.i === 94) {
      this.setEndTime(2);
      this.setNextEndDate(false);
    } else if (event.i === 95) {
      this.setEndTime(3);
      this.setNextEndDate(false);
    }
    this.onSubmit.emit(this.appointment);
  }

  getTimeByIndex(index) {
    return time.filter((t) => t.i === index)[0];
  }

  setEndTime(index) {
    const endHourSlots = this.getTimeByIndex(index);
    this.appointment.time.end = endHourSlots.value;
    this.selectedTime.end = endHourSlots;
  }

  setNextEndDate(today = true) {
    const current = this.helperService.convertDate(this.appointment.date.start);
    if (!today) {
      current.add(1, 'days');
    }
    this.appointment.date.end = current.toDate();
  }

  setSelectedTime() {
    this.getTimeDiffrence(this.appointment.time.start);

    for (let i = 0; i < this.times.length; i++) {
      const t = this.times[i];
      if (t.value === this.appointment.time.start) {
        this.selectedTime.start = t;
      }

      if (t.value === this.appointment.time.end) {
        this.selectedTime.end = t;
      }
    }
  }

  handleBlur(type: string) {
    this.focus[type] = false;
  }

  onFocusInput(type: string) {
    setTimeout(() => {
      this.acFocus[type] = true;
      for (const property in this.acFocus) {
        if (property !== type) {
          this.acFocus[property] = false;
        }
      }
    }, 100);
    this.onSubmit.emit(this.appointment);
  }

  onBlurInput(type: string) {
    setTimeout(() => (this.acFocus[type] = false), 100);
  }

  onSelectEndTime(event) {
    this.appointment.time.end = event.value;
    this.onSubmit.emit(this.appointment);
  }

  onEndDateSelect() {
    this.getTimeDiffrence(this.appointment.time.start);
    this.onSubmit.emit(this.appointment);
  }

  onSelectStartDate(event) {
    this.appointment.date.end = event;
    setTimeout(() => {
      this.focus.startTime = true;
    }, 100);
    this.getTimeDiffrence(this.appointment.time.start);

    this.onSubmit.emit(this.appointment);
  }

  getTimeDiffrence(start: any) {
    let startDate: any, endDate: any;
    if (this.appointment.date) {
      startDate = this.dateService.formatDate(this.appointment.date.start, datetimeFormat.mmmdyy);
      endDate = this.dateService.formatDate(this.appointment.date.end, datetimeFormat.mmmdyy);
    }

    if (startDate !== endDate) {
      this.endTimeDropdown = this.helperService.deepCopy(this.times);
    } else {
      this.endTimeDropdown = this.times.map((time) => {
        let todayDate: any;

        if (this.helperService.isAppleDevice()) {
          todayDate = moment(new Date()).format('MM/DD/YYYY');
        } else {
          todayDate = moment(new Date()).format('MM-DD-YYYY');
        }

        const startDate = new Date(`${todayDate} ${start}`);
        const endDate = new Date(`${todayDate} ${time.value}`);
        const timeDiff = Math.abs(startDate.getTime() - endDate.getTime());

        const hours = Math.abs(timeDiff) / 36e5;
        const diffTime = hours + ' Hr';
        const o: any = Object.assign({}, time);
        o.diffTime = `${o.label} (${diffTime})`;

        return o;
      });
    }

    this.endTimeDropdown.forEach((time) => {
      if (start < time.value || startDate !== endDate) {
        time.isActiveEndTime = true;
      }
    });
  }

  handleNote(e) {
    if (e) {
      this.appointment.description = e.target.value;
      this.onSubmit.emit(this.appointment);
    }
  }
}
